export default __webpack_public_path__ + "assets/webgl/picking-27.1fbdea61.glb";